import React from 'react';
import { useParams } from 'react-router-dom';
import CallCenter from '../../components/CallCenter';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Lnb from '../../components/Lnb';
import Location from '../../components/Location';

type Params = {
    resultCode: string;
}

const PsychlngclCheckStreeResult: React.FC = () => {
    const {resultCode} = useParams<Params>();
    const viewResult = (resultCode: string) => {
        switch(resultCode) {
            case "001" :
                return (
                    <>
                        <p className="result">님의 스트레스 수준은 낮음입니다.</p>
                        <p>스트레스가 하나도 없는 사람은 없습니다.
                            <br />스트레스가 낮다는 것은 스트레스에 잘 대처하고 있다는 뜻입니다.
                            <br />지금처럼 잘 관리한다면 스트레스에 지치지 않고 즐겁게 생활할 수 있습니다.
                            <br />평소 나의 스트레스 대처방법을 잘 알고 있다면 갑자기 극심한 스트레스가 생겼을 때도 유연하게 대처할 수 있습니다. 
                        </p>
                        <div className="tip">
                            <p><span>스트레스 관리 tip</span></p>
                            <ul className="li_common mt20">
                                <li>실현가능한 목표를 설정하고, 우선순위 정해 시간관리하기</li>
                                <li>가족, 친구 등 나를 지지해 줄 사람 만들기</li>
                                <li>규칙적인 식사와 운동으로 균형잡힌 생활하기</li>
                                <li>전문가와의 상담을 통해 그때그때 해소하기</li>
                            </ul>
                        </div>
                    </>
                )
            case "002" :
                return (
                    <>
                        <p className="result">님은 중간 정도의 스트레스를 느끼고 있는 편입니다.</p>
                        <p>스트레스가 무조건 나쁜 것은 아닙니다.
                            <br />적당한 스트레스는 생활의 활력과 원동력이 됩니다. 
                            <br />다만 스트레스가 너무 잦거나, 이를 제때 해소하지 못해 일상생활에 방해가 될 때 문제가 됩니다. 
                            <br />따라서 스트레스를 다스릴 수 있는 나만의 방법을 아는 것이 중요합니다. 
                        </p>
                        <div className="tip">
                            <p><span>스트레스 관리 tip</span></p>
                            <ul className="li_common">
                                <li>실현가능한 목표를 설정하고, 우선순위 정해 시간관리하기</li>
                                <li>가족, 친구 등 나를 지지해 줄 사람 만들기</li>
                                <li>규칙적인 식사와 운동으로 균형잡힌 생활하기</li>
                                <li>전문가와의 상담을 통해 그때그때 해소하기</li>
                            </ul>
                        </div>
                    </>
                )
            case "003" :
                return (
                    <>
                        <p className="result">님은 스트레스를 아주 많이 느끼고 있는 편입니다.</p>
                        <p>스트레스는 그 자체도 힘들지만, 스트레스로 인한 다음과 같은 증상으로 인해 더 많은 어려움을 겪기도 합니다.</p>
                        <div className="tip">
                            <p><span>스트레스로 인해 나타날 수 있는 증상</span></p>
                            <ul className="li_common mt20 mb20">
                                <li><strong>신체적 변화 : </strong>두통, 근육통, 심장 박동 및 혈압 상승, 복통, 입맛의 변화 등</li>
                                <li><strong>정서적 변화 : </strong>불안, 분노, 우울, 자존감이나 집중력 저하, 기억력 감퇴 등</li>
                                <li><strong>행동의 변화 : </strong>대인관계 갈등, 불면증, 과식, 과음, 업무능력 저하 등</li>
                            </ul>
                            <span className="lh20">그러나 스트레스는 관리할 수 있습니다. 상황을 바꿀 수 없더라도, 나의 반응과 대처가 달라지면 스트레스는 감소할 수 있습니다. 
                            <br />때로는 누군가와 이야기를 나누는 것만으로도 마음이 편해지기도 합니다. 
                            </span>
                        </div>
                    </>
                )
        }
    }

    return (
        <div id="warp">
            <Header />
            <section id="containers">
                <div className='therapy'>
                    <Lnb />
                    <div id="contents" className='contents'>
                        <h2>무료심리검사</h2>
                        <Location locations={[
                            {title: "토닥토닥마음케어", url: "/column/columnList"}
                            , {title: "무료심리검사", url: "/psychlgclCheck/main"}]} 
                            menuName='스트레스 자가진단'
                        />
                        <div className='mobileface testing'>
                            <div className="resultWrap stress">
                                <h3 className="f18 black">스트레스 자가진단</h3>
                                <h4 className="f14 green mt30">스트레스 자가진단 결과</h4>
                                <div className="total">
									{
                                        resultCode? (
                                            viewResult(resultCode)
                                        ) : (
                                            viewResult("001")
                                        )
                                    }
								</div>
                                <CallCenter />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    )
}

export default PsychlngclCheckStreeResult;